import { appDependencies } from "../AppDependencies";
import { IEmployeeGroup } from "./IEmployeeGroup";
import { IEmployeeGroupService } from "./IEmployeeGroupService";


export class EmployeeGroupService implements IEmployeeGroupService {
    saveEmployeeGroup(employeeGroup: IEmployeeGroup): Promise<any> {
        return appDependencies.IEmployeeGroupRepository.saveEmployeeGroup(employeeGroup);
    }
    getEmployeeGroups(): Promise<IEmployeeGroup[]> {
        return appDependencies.IEmployeeGroupRepository.getEmployeeGroups();
    }

    getEmployeeGroup(id: string): Promise<IEmployeeGroup | undefined> {
        return appDependencies.IEmployeeGroupRepository.getEmployeeGroup(id);
    }

    deleteEmployeeGroup(employeeGroup: IEmployeeGroup): Promise<any> {
        return appDependencies.IEmployeeGroupRepository.deleteEmployeeGroup(employeeGroup);
    }
}
